import React from "react";
import { Col } from "reactstrap";

import * as style from "./textBanner.module.scss";

const TextBanner = () => {
  return (
    <Col
      xs={{ size: 12 }}
      sm={{ size: 12 }}
      md={{ size: 12 }}
      lg={{ size: 12 }}
      xl={{ size: 12 }}
      className={style.textBanner}
    >
      <a href="http://behacne.net/ofeliatadeo">
        Accede al portfolio completo aquí.{" "}
        <b>Accede al portfolio completo aquí.</b>
      </a>
    </Col>
  );
};

export default TextBanner;
